<!-- OrderDetailBody.vue -->
<template>
    <div>
        <div class="common-header-wrap">
            <mt-header title="订单详情" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
        <div
                class="order-body"
                v-if="order_info"
        >
            <div class="order_state">
                <i class="iconfont" v-if="order_info.o2o_fuwu_order_state == '40'">&#xe61b;</i>
                <i class="iconfont" v-else>&#xe61a;</i>
                <span>{{order_info.o2o_fuwu_order_state_text}}</span>
            </div>

            <div class="address">
                <div>
                    <span>{{ order_info.o2o_fuwu_order_employer_name }}</span>
                    <span class="mobile" v-if="order_info.o2o_fuwu_order_employer_phone">{{ order_info.o2o_fuwu_order_employer_phone }}</span>
                </div>
                <p>
                    {{ order_info.o2o_fuwu_order_employer_address }}
                </p>
            </div>

            <div class="detail">
                <div class="number">
                    <p>
                        服务机构：{{ order_info.o2o_fuwu_organization_name }}
                    </p>
                    <p>
                        服务名称：{{ order_info.o2o_fuwu_goods_name }}
                    </p>
                    <p>
                        默认项目：{{order_info.o2o_fuwu_goods_spec_name}}×{{order_info.o2o_fuwu_order_default_quantity}}
                    </p>
                    <p class="spec-list" v-if="order_goods_spec_list && order_goods_spec_list.length>0">
                        <span>增值项目：</span><span><div v-for="(item,index) in order_goods_spec_list" :key="index">{{item.o2o_fuwu_goods_spec_name}}×{{item.o2o_fuwu_order_goods_spec_quantity}}</div></span>
                    </p>
                </div>
            </div>

            <div class="detail">
                <div class="number">
                    <label
                    >订单编号：{{ order_info.o2o_fuwu_order_sn }}
                    </label>
                    <p>
                        下单时间：{{$moment.unix(order_info.o2o_fuwu_order_add_time).format('YYYY-MM-DD HH:mm')}}
                    </p>
                    <p v-if="order_info.o2o_fuwu_order_appointment_time">
                        预约时间：{{$moment.unix(order_info.o2o_fuwu_order_appointment_time).format('YYYY-MM-DD')}} {{($moment.unix(order_info.o2o_fuwu_order_appointment_time).format('HH')<12)?'上午':'下午'}}
                    </p>
                    <p v-if="order_info.o2o_fuwu_order_payment_time">
                        支付时间：{{$moment.unix(order_info.o2o_fuwu_order_payment_time).format('YYYY-MM-DD HH:mm')}}
                    </p>
                    <p v-if="order_info.o2o_fuwu_order_arrange_time">
                        安排时间：{{$moment.unix(order_info.o2o_fuwu_order_arrange_time).format('YYYY-MM-DD HH:mm')}}
                    </p>
                    <p v-if="order_info.o2o_fuwu_order_serve_time">
                        服务时间：{{$moment.unix(order_info.o2o_fuwu_order_serve_time).format('YYYY-MM-DD HH:mm')}}
                    </p>
                    <p v-if="order_info.o2o_fuwu_order_finish_time">
                        完成时间：{{$moment.unix(order_info.o2o_fuwu_order_finish_time).format('YYYY-MM-DD HH:mm')}}
                    </p>
                </div>

            </div>

            <div class="detail" v-if="order_info.o2o_fuwu_order_remark!=''">
                <div class="number">
                    <p>
                        备注：{{ order_info.o2o_fuwu_order_remark }}
                    </p>

                </div>
            </div>

            <div
                    class="desc section-header section-footer"
            >
                <div class="container">
                    <label class="title">基础服务费</label>
                    <label class="subtitle">￥{{ order_info.o2o_fuwu_order_default_amount }}</label>
                </div>
                <div class="container" v-if="order_info.o2o_fuwu_order_added_amount!=0">
                    <label class="title">增值服务费</label>
                    <label class="subtitle">￥{{ order_info.o2o_fuwu_order_added_amount }}</label>
                </div>

                <label class="amount"
                >实付款 : <span> ￥{{ order_info.o2o_fuwu_order_amount }}</span>
                </label>
            </div>

        </div>
    </div>
</template>

<script>

import { Toast, MessageBox } from 'mint-ui'
import { getFuwuOrderInfo } from '../../../api/memberO2oFuwuOrder'
export default {
  name: 'MemberO2oFuwuOrderDetail',
  data () {
    return {
      order_info: {},
      order_goods_spec_list: false
    }
  },

  created: function () {
    if (this.$route.query.o2o_fuwu_order_id) {
      getFuwuOrderInfo(this.$route.query.o2o_fuwu_order_id).then(res => {
        this.order_info = res.result.o2o_fuwu_order_info
        this.order_goods_spec_list = res.result.o2o_fuwu_order_goods_spec_list
      }).catch(function (error) {
        Toast(error.message)
      })
    }
  },
  methods: {

  }
}
</script>
<style lang="scss" scoped>
    .order-body {
        overflow: auto;
        height: 100%;
        position: absolute;
        width: 100%;
        .desc{
            .container {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;
                background-color: #fff;
            }
            .title {
                width: 5rem;
                font-size: 0.7rem;
                color: #4e545d;
                margin-left: 0.6rem;
            }
            .subtitle {
                flex: 1;
                margin-left: 1rem;
                margin-right: 0.6rem;
                color: $primaryColor;
                font-size: 0.7rem;
                text-align: right;
            }
        }

    }
    .order_state {
        background:#fa800a;
        height: 3.5rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        i {
            color:#fff;
            font-size:1.2rem;
            padding: 0 0.5rem;
        }
        span {
            font-size: 0.8rem;
            color: #fff;
        }
    }
    .containers {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: stretch;
        background-color: #fff;
        border-bottom: 1px solid #e8eaed;
    }
    .photo {
        width: 4rem;
        height: 4rem;
        margin: 0.75rem 0.5rem 0.75rem 0.75rem;
        border: 1px solid #e8eaed;
        flex-basis: 4rem;
        flex-shrink: 0;
    }
    .right-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;
        padding: 0 0.75rem 0 0;
        width: 100%;
        overflow: hidden;
    }
    .title {
        color: #4e545d;
        font-size: 0.7rem;

        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .property {
        font-size: 0.65rem;
        color: #999999;
        padding-top: 0.5rem;
    }
    .count {
        margin-top: 0.2rem;
        color: #999999;
        font-size: 0.65rem;
        margin-right: 0.5rem;
    }
    .desc-wrapper {
        height: 1rem;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding-top: 1rem;
    }
    .price {
        color: $primaryColor;
        font-size: 0.8rem;
        margin-left: 0;
    }
    .count {
        color: #999999;
        font-size: 0.8rem;
        margin-left: 0.5rem;
    }
    .address {
        height: 4.4rem;
        background-color: #fff;
        margin-bottom: 0.5rem;
        div {
            padding: 0.55rem 0.5rem 0;
        }
        img {
            height: 0.8rem;
        }
        span {
            color: #4e545d;
            font-size: 0.8rem;
            &.mobile {
                padding-left: 1rem;
            }
        }
        p {
            margin: 0.25rem 0.9rem 0.55rem 0.5rem;
            font-size: 0.7rem;
            color: #999999;

            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
        }
    }

    .contact {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        height: 2.3rem;
        background-color: #fff;
        margin-top: 0.4rem;
        border-bottom: 1px solid #e8eaed;
        padding: 0 0.65rem;
        span {
            font-size: 0.6rem;
            color: #4e545d;
            padding-right: 0.3rem;
        }
        img {
            width: 0.6rem;
            height: 0.65rem;
        }
    }

    .detail {
        display: flex;
        flex-direction: column;
        font-size: 0.7rem;
        color: #999999;
        background-color: #fff;
        margin: 0.4rem 0;
        box-sizing: border-box;
        .number {
            padding: 0.7rem 0.8rem;
            border-bottom: 1px solid #e8eaed;
            p {
                padding-top: 0.3rem;
                font-size: 0.7rem;
            }
            button {
                color: #999999;
                height: 1rem;
                background-color: #fff;
                border: 1px solid #999999;
                width: 2.7rem;
                height: 1rem;
                border-radius: 0.1rem;
                font-size: 0.7rem;
            }
        }
        .pay {
            border-bottom: 1px solid #e8eaed;
            padding: 0.7rem 0.8rem;
        }
        .givetime {
            padding: 0.7rem 0.8rem;
            font-size: 0.7rem;
        }
        input {
            background-color: #fff;
            border: 1px solid #999999;
        }
    }
    .desc {
        background-color: #fff;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;
        padding-top: 0.6rem;
        box-sizing: border-box;
        margin-bottom: 4rem;
        .desc-item {
            flex: 1;
            margin-top: 0.5rem;
        }
        .amount {
            display: flex;
            justify-content: flex-end;
            font-size: 0.7rem;
            color: #4e545d;
            padding-right: 0.75rem;
            border-top: 1px solid #e8eaed;
            margin-top: 0.6rem;
            height: 2.25rem;
            line-height: 2.25rem;
            span {
                font-size: 0.8rem;
                color: $primaryColor;
            }
        }
    }
    .ship {
        margin-bottom: 0;
    }
    .spec-list > span{display: inline-block;vertical-align: top}
</style>

<!-- 字体图标样式覆盖 -->
<style>
    .mint-toast-icon {
        font-size: 1.9rem;
    }
    button {
        padding: 0;
    }
</style>
